var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 47,
    viewBox: "0 0 43 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6972 37.4864L22.0534 44.8425C22.7464 45.5559 23.716 45.9994 24.7893 45.9994C26.8956 45.9994 28.6029 44.2918 28.6029 42.1858C28.6029 41.1126 28.1595 40.1429 27.4461 39.45L12 24.0039",
    fill: "url(#paint0_linear_2727_260)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6972 37.4864L22.0534 44.8425C22.7464 45.5559 23.716 45.9994 24.7893 45.9994C26.8956 45.9994 28.6029 44.2918 28.6029 42.1858C28.6029 41.1126 28.1595 40.1429 27.4461 39.45L12 24.0039",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6136 3.69727L11.092 24.0052L2.11697 32.9803C0.627677 34.4695 0.627677 36.8842 2.11697 38.3735L4.81363 41.0701C6.30292 42.5594 8.71757 42.5594 10.2069 41.0701L19.1819 32.0951L39.4898 22.5735",
    fill: "#EBF5FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6136 3.69727L11.092 24.0052L2.11697 32.9803C0.627677 34.4695 0.627677 36.8842 2.11697 38.3735L4.81363 41.0701C6.30292 42.5594 8.71757 42.5594 10.2069 41.0701L19.1819 32.0951L39.4898 22.5735",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1874 25.2693L17.918 1",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3086 10.6015L42.1899 8.62695",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5859 4.88134L34.5605 1",
    stroke: "#022356",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 24L19.5 32",
    stroke: "#022356",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2727_260",
    x1: 18.5,
    y1: 34,
    x2: 28.7984,
    y2: 42.0651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2561"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/Marketing.18a018736b61692f9caf7e915b5cd4c5.svg";
export { ForwardRef as ReactComponent };